<template>
  <div>
    <div class="lke-titl">
      <div>
        <i class="el-icon-caret-right"></i>
        当前位置：课程评估
      </div>
      <div></div>
    </div>
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="评估列表" name="0">
        <el-table :data="list" v-loading="listLoading" style="width: 100%">
          <el-table-column prop="title" label="问卷名称"></el-table-column>
          <el-table-column label="课程评估" width="180">
            <template slot-scope="{ row }">
              <router-link
                :to="'/grzx/assess/' + row._id"
                style="text-decoration: none"
              >
                <span class="lke-button" @click="getClass(row)">
                  开始评估
                </span>
              </router-link>
            </template>
          </el-table-column>
        </el-table>
        <div class="lke-fot">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="page"
            layout="total, prev, pager, next"
            :total="total"
          >
          </el-pagination>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { gettbsurveysubmit } from "@/api/index";
export default {
  props: {},
  data() {
    return {
      listLoading: false,
      input: "",
      limit: 20,
      total: 0,
      page: 1,
      activeName: "0",
      list: [],
    };
  },
  computed: {},
  created() {
    this.gettbsurveysubmit();
  },
  mounted() {},
  watch: {},
  methods: {
    getClass() {},

    gettbsurveysubmit() {
      this.listLoading = true;
      let obj = {
        limit: this.limit,
        page: this.page,
      };
      gettbsurveysubmit(obj)
        .then((response) => {
          this.list = response.result;
          this.total = response.count;
          this.listLoading = false;
        })
        .catch(() => {
          this.listLoading = false;
        });
    },

    handleSizeChange(val) {},
    handleCurrentChange(val) {
      this.page = val;
      this.gettbsurveysubmit();
    },
  },
  components: {},
};
</script>

<style>
.el-tabs__item.is-active {
  color: #2890f4;
}
.el-tabs__active-bar {
  background: #2890f4;
}
.el-tabs__item {
  font-size: 16px;
  font-weight: bold;
}
</style>

<style scoped>
.lke-titl {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  padding-bottom: 20px;
}
.lke-titl > div:first-child {
  display: flex;
  align-items: center;
}
.lke-titl i {
  color: #2890f4;
  padding-right: 5px;
  font-size: 20px;
}
.lke-button {
  padding: 5px 15px;
  background: #2890f4;
  cursor: pointer;
  color: #fff;
  border-radius: 5px;
}
.lke-fot {
  padding: 20px;
  display: flex;
  justify-content: center;
  background: #f2f2f2;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/page/grzx/courseAssess/courseAssess.vue